import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function formatError(detail) {
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return "Login failed. Please try again.";
}

export default function AdminLogin() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, form);
      localStorage.setItem("uw_token", data.token);
      navigate("/admin");
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center px-6">
      <form data-testid="admin-login-form" onSubmit={submit} className="w-full max-w-md bg-[#171717] border border-white/10 p-8 flex flex-col gap-5">
        <div className="flex flex-col items-center gap-3 mb-2">
          <img src="/logo.png" alt="Ultimate Warrior Junk and Plow Removal logo" className="h-24 w-auto" />
          <h1 className="font-display uppercase text-3xl tracking-wide">Owner Login</h1>
        </div>
        <div>
          <label htmlFor="admin-email" className="text-xs tracking-[0.2em] uppercase font-bold text-neutral-400 block mb-2">Email</label>
          <Input
            id="admin-email"
            data-testid="admin-email-input"
            type="email"
            required
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            className="bg-[#0A0A0A] border-white/20 rounded-none p-4 h-auto focus-visible:ring-[#F59E0B]"
          />
        </div>
        <div>
          <label htmlFor="admin-password" className="text-xs tracking-[0.2em] uppercase font-bold text-neutral-400 block mb-2">Password</label>
          <Input
            id="admin-password"
            data-testid="admin-password-input"
            type="password"
            required
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            className="bg-[#0A0A0A] border-white/20 rounded-none p-4 h-auto focus-visible:ring-[#F59E0B]"
          />
        </div>
        <button
          data-testid="admin-login-submit"
          type="submit"
          disabled={loading}
          className="inline-flex items-center justify-center gap-2 bg-[#F59E0B] text-black font-display uppercase tracking-wider text-2xl px-8 py-4 hover:bg-[#D97706] transition-colors duration-200 active:scale-95 disabled:opacity-60"
        >
          {loading && <Loader2 className="w-5 h-5 animate-spin" />}
          {loading ? "Signing in..." : "Sign In"}
        </button>
        <a data-testid="admin-back-home-link" href="/" className="text-xs text-neutral-500 hover:text-[#F59E0B] transition-colors duration-200">Back to website</a>
      </form>
    </div>
  );
}
